import AnimButton from "./Animation/AnimButton";

const Header = () => {
	return (
		<header className="header">
			<a href="#" className="header__logo">
				<img
					className="header__logo-icon"
					src="./img/header/Logo_SlonUM_V1.svg"
					alt="logo elsmart"
				/>
				<p className="header__logo-text">
					El<span className="header__logo-detail">Smart</span>
				</p>
			</a>

			<AnimButton />
		</header >
	);
};

export default Header;
